import { BenchmarkEntity } from "@modules/benchmark/entities/benchmarkEntity"
import { useServicesContext } from "@modules/core/services/services.context"
import { useQuery } from "@tanstack/react-query"

export const useBenchmark = (id?: string) => {
  const { benchmarkApi } = useServicesContext()

  const { data, isLoading } = useQuery({
    queryKey: ["benchmark", id],
    queryFn: async () => {
      return !!id && (await benchmarkApi.getBenchmark(id))
    },
    enabled: !!id,
  })

  return {
    data: data ? BenchmarkEntity.fromDto(data) : undefined,
    isLoading,
  }
}
